import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CakeVendorHome.css';

const CakeVendorHome = () => {
  const navigate = useNavigate();

  let vendor = {};

  try {
    vendor = JSON.parse(localStorage.getItem('cakeVendor')) || {};
  } catch (error) {
    vendor = {};
  }

  const handleLogout = () => {
    localStorage.removeItem('cakeToken');
    localStorage.removeItem('cakeVendor');
    navigate('/cake/login');
  };

  return (
    <div className="cake-vendor-page">
      {/* SIDEBAR */}
      <aside className="cake-vendor-sidebar">
        <div className="cake-vendor-brand">
          <div className="cake-vendor-logo">
            🎂
          </div>

          <div>
            <h2>VAKRA CAKE</h2>
            <span>Vendor Panel</span>
          </div>
        </div>

        <nav className="cake-vendor-menu">
          <button className="active">
            <span>🏠</span>
            Home
          </button>

          <button
            type="button"
            onClick={() => navigate('/cake/cakes')}
          >
            <span>🎂</span>
            Cakes
          </button>

          <button
            type="button"
            onClick={() => navigate('/cake/orders')}
          >
            <span>📦</span>
            Orders
          </button>

          <button>
            <span>👥</span>
            Customers
          </button>

          <button>
            <span>🧾</span>
            Billing
          </button>

          <button>
            <span>📊</span>
            Records
          </button>

          <button
            type="button"
            onClick={() => navigate('/cake/settings')}
          >
            <span>⚙️</span>
            Settings
          </button>
        </nav>

        <div className="cake-vendor-sidebar-bottom">
          <button
            type="button"
            className="cake-vendor-logout"
            onClick={handleLogout}
          >
            <span>↪</span>
            Logout
          </button>
        </div>
      </aside>

      {/* MAIN AREA */}
      <main className="cake-vendor-main">

        {/* TOP BAR */}
        <header className="cake-vendor-topbar">
          <div>
            <h3>
              Home
            </h3>

            <p>
              Welcome to your cake business panel.
            </p>
          </div>

          <div className="cake-vendor-profile">
            <div className="cake-vendor-profile-icon">
              {vendor.shop_name
                ? vendor.shop_name.charAt(0).toUpperCase()
                : 'C'}
            </div>

            <div className="cake-vendor-profile-info">
              <strong>
                {vendor.shop_name || 'Cake Shop'}
              </strong>

              <span>
                {vendor.vendor_code || 'VAKRA Vendor'}
              </span>
            </div>
          </div>
        </header>

        {/* PAGE CONTENT */}
        <section className="cake-vendor-content">

          {/* WELCOME */}
          <div className="cake-vendor-welcome">
            <div>
              <span className="cake-vendor-small-label">
                VAKRA CAKE
              </span>

              <h1>
                Welcome,{' '}
                {vendor.owner_name || 'Vendor'} 👋
              </h1>

              <p>
                Manage your cakes, customer orders,
                billing and business records from here.
              </p>
            </div>

            <button
              type="button"
              className="cake-add-cake-button"
              onClick={() => navigate('/cake/cakes/add')}
            >
              + Add Cake
            </button>
          </div>

          {/* SUMMARY CARDS */}
          <div className="cake-vendor-summary-grid">
            <div className="cake-summary-card">
              <div className="cake-summary-icon purple">
                📦
              </div>

              <div>
                <span>Today's Orders</span>

                <strong>
                  0
                </strong>
              </div>
            </div>

            <div className="cake-summary-card">
              <div className="cake-summary-icon orange">
                ⏳
              </div>

              <div>
                <span>Pending Orders</span>

                <strong>
                  0
                </strong>
              </div>
            </div>

            <div className="cake-summary-card">
              <div className="cake-summary-icon green">
                ₹
              </div>

              <div>
                <span>Today's Sales</span>

                <strong>
                  ₹0
                </strong>
              </div>
            </div>

            <div className="cake-summary-card">
              <div className="cake-summary-icon blue">
                🎂
              </div>

              <div>
                <span>Total Cakes</span>

                <strong>
                  0
                </strong>
              </div>
            </div>
          </div>

          {/* LOWER SECTION */}
          <div className="cake-vendor-lower-grid">

            {/* RECENT ORDERS */}
            <div className="cake-vendor-panel">
              <div className="cake-vendor-panel-heading">
                <div>
                  <h2>
                    Recent Orders
                  </h2>

                  <p>
                    Latest customer cake orders.
                  </p>
                </div>

                <button
                  type="button"
                  onClick={() => navigate('/cake/orders')}
                >
                  View All
                </button>
              </div>

              <div className="cake-empty-orders">
                <div className="cake-empty-icon">
                  📦
                </div>

                <h3>
                  No Orders Yet
                </h3>

                <p>
                  New customer orders will appear here.
                </p>
              </div>
            </div>

            {/* UPCOMING DELIVERY */}
            <div className="cake-vendor-panel">
              <div className="cake-vendor-panel-heading">
                <div>
                  <h2>
                    Upcoming Orders
                  </h2>

                  <p>
                    Today's cake deliveries and pickups.
                  </p>
                </div>
              </div>

              <div className="cake-empty-orders">
                <div className="cake-empty-icon">
                  📅
                </div>

                <h3>
                  No Upcoming Orders
                </h3>

                <p>
                  Scheduled orders will appear here.
                </p>
              </div>
            </div>
          </div>

          {/* QUICK ACTIONS */}
          <div className="cake-quick-section">
            <div className="cake-vendor-panel-heading">
              <div>
                <h2>
                  Quick Actions
                </h2>

                <p>
                  Common cake business actions.
                </p>
              </div>
            </div>

            <div className="cake-quick-grid">

              <button
                type="button"
                onClick={() => navigate('/cake/cakes/add')}
              >
                <div className="cake-quick-icon">
                  🎂
                </div>

                <div>
                  <strong>
                    Add Cake
                  </strong>

                  <span>
                    Add a new cake product
                  </span>
                </div>
              </button>

              <button
                type="button"
                onClick={() => navigate('/cake/orders')}
              >
                <div className="cake-quick-icon">
                  📦
                </div>

                <div>
                  <strong>
                    View Orders
                  </strong>

                  <span>
                    Check customer orders
                  </span>
                </div>
              </button>

              <button type="button">
                <div className="cake-quick-icon">
                  👥
                </div>

                <div>
                  <strong>
                    Customers
                  </strong>

                  <span>
                    View customer records
                  </span>
                </div>
              </button>

              <button type="button">
                <div className="cake-quick-icon">
                  📊
                </div>

                <div>
                  <strong>
                    Records
                  </strong>

                  <span>
                    View sales and order history
                  </span>
                </div>
              </button>

            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default CakeVendorHome;
